import { render, staticRenderFns } from "./formpreview.vue?vue&type=template&id=fa4415a6&scoped=true"
import script from "./formpreview.vue?vue&type=script&lang=js"
export * from "./formpreview.vue?vue&type=script&lang=js"
import style0 from "./formpreview.vue?vue&type=style&index=0&id=fa4415a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4415a6",
  null
  
)

export default component.exports